import { Component, Input, OnInit } from '@angular/core';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { SupAssGatherDetailService } from '../../../../routes/jy-srm/supplier/supAss/supAssGather/sup-ass-gather-detail.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { configData } from '../../../../routes/jy-srm/supplier/supplier-config/assessment/indicators/configData';
import { SupAssOrderServiceDtService } from '../../../../routes/jy-srm/supplier/supAss/sup-ass-order-service-dt.service';

@Component({
  selector: 'app-sup-ass-quail-dt',
  templateUrl: './sup-ass-quail-dt.component.html',
  styles: []
})
export class SupAssQuailDtComponent implements OnInit {

  static componentName = 'SupAssQuailDtComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;
  configData = configData;
  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(
    private commonsService:CommonsService,
    private modalService:NzModalService,
    private supAssOrderServiceDtService:SupAssOrderServiceDtService
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      params = params.append('propertyNames', 'isDeleted');
      params = params.append('propertyValues', 'false');
      console.log(params);
      return supAssOrderServiceDtService.query(params);
    }
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {

    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);

        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

}
